import React from 'react';
import { connect } from 'dva';
import BaseComponent from '../../../components/BaseComponent';
//import { Chart } from 'react-google-charts';
import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
  Markers,
  Marker,
} from "react-simple-maps"
import config from '../config/config';
//const MapFile = '/geo/oceania.geo.json';
const MapFile = '/geo/japan.json';
const {mapStyle, circleStyle} = config.travel.map;

const google = window.google;

class EntryMap extends BaseComponent {
  constructor(props) {
    super(props);

//    this.showModal = this.showModal.bind(this);
//    this.hideModal = this.hideModal.bind(this);
  }
/*
  componentWillMount() {

  }
*/
  render() {
/*
    var options = {
//      displayMode: 'text'
      sizeAxis: { minValue: 0, maxValue: 100 },
      region: '155', // Western Europe
      displayMode: 'markers',
      colorAxis: {colors: ['#e7711c', '#4374e0']} // orange to blue
    };
    var options = {
      displayMode: 'text'
    };
    var data = [
      ['Germany',202],
      ['France', 600],
      ['Russia', 700],
    ];

    var columns = [
      {
        'type': 'string',
        'label' : 'Country'
      },
      {
        'type' : 'number',
        'label' : 'Number'
      }
    ];
    */

    return(
      <section>
        <ComposableMap
          projectionConfig={{
            scale: 1000,
          }}
          width={600}
          height={480}
          style={{
            width: "100%",
            height: "auto",
          }}
        >
          <ZoomableGroup
            center={[-24.499609, 133.802072]}
            disablePanning>
            <Geographies geography="/geo/world-110m.json">
              {(geographies, projection) => geographies.map((geography, i) => geography.id !== "ATA" && (
                <Geography
                  key={i}
                  geography={geography}
                  projection={projection}
                  style={mapStyle}
                />
              ))}
            </Geographies>
          </ZoomableGroup>
        </ComposableMap>

        {/*
        <Chart chartType="GeoChart"
               width={"900px"}
               height={"500px"}
               data={data}
               columns={columns}
               options={options}
               graph_id="GeoChart"
               legend_toggle={true}/>
*/}

      </section>
    )
  }
}


export default connect(({ travel }) => ({
  travel
}))(EntryMap);


// WEBPACK FOOTER //
// ./src/pages/travel/components/EntryMap.js